




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { PageObject } from './Footer.vue';

@Component({
  data: () => {
    return {
      title: '',
      content: '',
    };
  },
})
export default class Modal extends Vue {
  private title!: string;
  private content!: string;

  public show(page: PageObject) {
    this.modal().modal('show');
    this.title = page.title;
    const content = page.content;
    if (typeof content === 'string') {
      this.content = content;
    } else {
      this.content = content.join('\n');
    }
  }

  private modal() {
    return $(this.$refs.modal);
  }
}
